import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import { accessTokenAtom } from '../atoms/authAtom';
import { useShelterActions } from './useShelter';
import { switchShelter as switchShelterAPI, updateBackendTokenCache } from '../services/api';

export const useShelterSwitch = () => {
  const setAccessToken = useSetAtom(accessTokenAtom);
  const { getCurrentShelter } = useShelterActions();

  const switchShelter = useCallback(
    async (newSoldTo: string): Promise<boolean> => {
      try {
        const response = await switchShelterAPI(newSoldTo);

        setAccessToken(response.token);
        updateBackendTokenCache(response.token);

        const authState = {
          token: response.token,
          expiresAt: Date.now() + response.expiresIn * 1000,
        };
        localStorage.setItem('hills_fsl_auth', JSON.stringify(authState));

        await getCurrentShelter();

        // Reload the page to ensure all components refresh with new shelter context
        window.location.reload();

        return true;
      } catch (error) {
        console.error('[useShelterSwitch] Failed to switch shelter:', error);
        return false;
      }
    },
    [setAccessToken, getCurrentShelter]
  );

  return { switchShelter };
};
